var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('PageHeader'),_c('div',{staticClass:"main"},[(_vm.$route.meta && _vm.$route.meta.keepAlive)?_c('keep-alive',[_c('router-view')],1):_vm._e(),(_vm.$route.meta && !_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_c('PageFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }